import { Col, Container, Row } from "react-bootstrap";
import "./What_Makes_Hindustan_Solar_Different.css";
import { WhatMakeDifferents } from "../../../utils/apis/aboutus/Aboutus.js";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";

const pointsData = [
  {
    title: "Execution-Driven Company",
    description:
      "Built by real EPC professionals, not traders or commission agents.",
  },
  {
    title: "Strong After-Sales Support",
    description:
      "We remain connected with customers even after commissioning.",
  },
  {
    title: "Ethical Pricing Policy",
    description:
      "We avoid low-margin shortcuts that compromise system quality or service.",
  },
  {
    title: "Safety-First Culture",
    description:
      "Rooftop safety, handrail systems, structured installation & trained teams.",
  },
  {
    title: "Government & Compliance Expertise",
    description:
      "We simplify subsidy, net-metering & TOD for customers.",
  },
  {
    title: "Local Strength, Regional Leadership",
    description:
      "Being based in Konkan, we provide faster service & personal support than outside vendors.",
  },
  {
    title: "Customer Education & Transparency",
    description:
      "We educate customers before selling, ensuring long-term trust.",
  },
];

const WhatMakesHindustanDifferent = () => {

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const { IMG_URL } = useContext(Context);

  const [whatmakedifferent, setWhatMakeDifferent] = useState([]);

  const getWhatMakeDifferent = async () => {
    const res = await WhatMakeDifferents();

    if (res?.success) {
      setWhatMakeDifferent(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getWhatMakeDifferent();
  }, []);

  return (
    <section className="hindustan_section">
      <Container>
        <Row className="align-items-center justify-content-center hindustan_row">
          
          {/* Left Image */}
          <Col lg={5} md={6} sm={6} xs={6} className="mb-4 mb-lg-0">
            <div className="hindustan_image">
              <img
                src="/assets/images/aboutus/man-worker-firld-by-solar-panels.png"
                alt="Solar Engineer"
                className="solar_man_img"
              />
            </div>
          </Col>

          {/* Right Content */}
          <Col lg={7}>
            <div className="hindustan_content">
              <h2 className="hindustan_title">
                What Makes Hindustan Solar Different?
              </h2>

              <div className="points_wrapper">
                {whatmakedifferent.map((item, index) => (
                  <div className="single_point" key={index}>
                    <h5>
                      <span className="point_number">
                        {index + 1}.
                      </span>{" "}
                      {item.name}
                    </h5>
                    <p>{htmlToReactParser.parse(item.description)}</p>
                  </div>
                ))}
              </div>
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default WhatMakesHindustanDifferent;
